import React, { useState } from "react";
import axios from "axios";
import LibrariesList from "../../videoLibaries/VideoLibaries";

const CreateLessonModal = ({
  isOpen,
  onClose,
  lessonType,
  quotaId,
  courseId,
  onLessonCreated,
  setRefreshFlag,
}) => {
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [videoId, setVideoId] = useState("");
  const [isDriveVideo, setIsDriveVideo] = useState(true);
  const [libraryId, setLibraryId] = useState(null);
  const [duration, setDuration] = useState(30);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const apiBase = process.env.REACT_APP_API;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const endpoint =
        lessonType === "video" ? "/lessons/video" : "/lessons/pdf";

      const payload =
        lessonType === "video"
          ? {
              videoID: videoId,
              videoTitle: title,
              course_id: courseId,
              quotaId: quotaId,
              isDriveVideo: isDriveVideo,
              videoLibraryId: libraryId,
              allowedTime: duration,
            }
          : {
              url: url,
              pdfTitle: title,
              courseId: courseId,
              quotaId: quotaId,
            };

      const response = await axios.post(`${apiBase}${endpoint}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      onLessonCreated(response.data);
      onClose();
      setTitle("");
      setUrl("");
      setVideoId("");

      setRefreshFlag((prev) => !prev);
    } catch (err) {
      setError(err.response?.data?.message || "Error creating lesson");
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg w-full max-w-md p-6">
        <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100">
          Add New {lessonType === "video" ? "Video" : "PDF"}
        </h2>

        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                {lessonType === "video" ? "Video Title" : "PDF Title"}
              </label>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                required
                placeholder={
                  lessonType === "video"
                    ? "Enter video title"
                    : "Enter PDF title"
                }
              />
            </div>

            {lessonType === "video" ? (
              <>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    {isDriveVideo ? "URL" : "Video ID"}
                  </label>
                  <input
                    type="text"
                    value={videoId}
                    onChange={(e) => setVideoId(e.target.value)}
                    className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                    required
                    placeholder={isDriveVideo ? "URL" : "Video ID"}
                  />
                </div>
                {!isDriveVideo && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Duration
                    </label>
                    <input
                      type="number"
                      value={duration}
                      onChange={(e) => setDuration(e.target.value)}
                      className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                      required
                      placeholder={"Duration in minutes"}
                    />
                  </div>
                )}

                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="isDriveVideo"
                    checked={isDriveVideo}
                    onChange={(e) => setIsDriveVideo(e.target.checked)}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label
                    htmlFor="isDriveVideo"
                    className="ml-2 block text-sm text-gray-700 dark:text-gray-300"
                  >
                    Is Drive Video
                  </label>
                </div>
                {!isDriveVideo && (
                  <div>
                    <LibrariesList
                      libraryId={libraryId}
                      setLibraryId={setLibraryId}
                    />
                  </div>
                )}
              </>
            ) : (
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  PDF URL
                </label>
                <input
                  type="url"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                  required
                  placeholder="Enter PDF URL"
                />
              </div>
            )}

            {error && (
              <div className="text-red-600 dark:text-red-400 text-sm">
                {error}
              </div>
            )}

            <div className="flex justify-end space-x-3 mt-6">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isLoading}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-400"
              >
                {isLoading ? "Creating..." : "Create"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateLessonModal;
